// VIEWING — confidential letter form. NOT a generic contact form.
export default function Viewing() {
  return (
    <div className="bg-[#F4EFE5] text-[#0E1B2D] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-2 border-[#1F3A5F]">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#7B5527] mb-3">— Office IV / Private viewing</p>
        <h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95] text-[#1F3A5F]">A letter to the office.</h1>
      </section>

      <section className="max-w-[1100px] mx-auto px-8 lg:px-14 py-14 grid lg:grid-cols-[1fr_280px] gap-12 items-start">
        {/* LETTER FORM — typewriter on cream paper */}
        <form onSubmit={(e) => e.preventDefault()} className="bg-white border border-[#1F3A5F]/20 p-8 lg:p-12 shadow-[0_2px_0_rgba(31,58,95,0.08)]">
          <div className="border-b-2 border-[#1F3A5F] pb-3 mb-6 flex items-baseline justify-between">
            <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B5527]">Letter of introduction</p>
            <p className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#1F3A5F]/55">Confidential · 2026</p>
          </div>
          <p className="font-serif text-base text-[#1F3A5F]/65 mb-7 leading-[1.7]">All inquiries are received personally by the office director. We respond within 48 hours by hand-typed reply. References are not required for first conversations.</p>
          <div className="grid grid-cols-2 gap-x-6 gap-y-5">
            <Field label="Full name" testId="ml-form-name" />
            <Field label="Country of residence" testId="ml-form-country" />
            <Field label="Email" type="email" testId="ml-form-email" />
            <Field label="Telephone" type="tel" testId="ml-form-tel" />
            <SelectField label="Estate of interest" testId="ml-form-estate" options={['ML-118 — Further Lane Residence','ML-119 — Red Mountain Compound','ML-120 — Villa La Pinède','ML-121 — Sagaponack Oceanfront','ML-122 — Owl Creek Lodge','ML-123 — Domaine du Phare','ML-125 — Castle Creek Ranch','ML-128 — Maroon Bells Reserve','Multiple / advisory only']} />
            <SelectField label="Acquisition timeline" testId="ml-form-timeline" options={['Immediate','3–6 months','6–12 months','Confidential']} />
            <div className="col-span-2">
              <label className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B5527] block mb-2">Letter to the office director</label>
              <textarea data-testid="ml-form-letter" rows="6" className="w-full bg-transparent border border-[#1F3A5F]/25 px-4 py-3 outline-none focus:border-[#1F3A5F] resize-none font-serif text-base leading-relaxed" placeholder="Dear office,&#10;&#10;I would be grateful for a private viewing of…" />
            </div>
            <button type="button" data-testid="ml-form-submit" className="col-span-2 bg-[#1F3A5F] text-[#F4EFE5] px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#7B5527] transition-colors w-full sm:w-auto sm:justify-self-start">Send letter →</button>
          </div>
          <p className="font-mono text-[9px] tracking-[0.3em] uppercase text-[#1F3A5F]/40 mt-7 pt-4 border-t border-[#1F3A5F]/10">Replies hand-signed by Eleanor Gault, Director · NY-7714</p>
        </form>

        {/* SIDEBAR — director card */}
        <aside className="lg:sticky lg:top-28 space-y-7">
          <div className="bg-[#FAF6EC] border border-[#1F3A5F]/20 p-6">
            <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B5527] mb-3">Office director</p>
            <p className="font-serif italic text-2xl text-[#1F3A5F]">Eleanor Gault</p>
            <p className="font-serif text-sm text-[#1F3A5F]/65 mt-1">Director · 22 years</p>
            <p className="text-xs text-[#1F3A5F]/65 mt-4 leading-[1.65]">Eleanor leads first conversations and personally tours every estate. She replies in writing within two business days.</p>
          </div>
          <div className="border-l-2 border-[#7B5527] pl-5">
            <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B5527] mb-2">Hours · By appointment</p>
            <p className="font-serif text-sm text-[#1F3A5F]/85 leading-[1.65]">Mon — Fri · 9 — 6<br />Sat · by appointment<br />Sunday closed</p>
          </div>
          <div className="border-l-2 border-[#1F3A5F]/30 pl-5">
            <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#1F3A5F]/65 mb-2">Direct line</p>
            <p className="font-mono text-sm text-[#1F3A5F]">+1 (212) 555 0118<br />director@maisonluxe.co</p>
          </div>
        </aside>
      </section>
    </div>
  );
}

function Field({ label, type = 'text', testId }) {
  return (
    <div className="col-span-2 sm:col-span-1">
      <label className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B5527] block mb-2">{label}</label>
      <input type={type} data-testid={testId} className="w-full bg-transparent border-b border-[#1F3A5F]/30 px-1 py-2 outline-none focus:border-[#1F3A5F] font-serif text-base" />
    </div>
  );
}
function SelectField({ label, options, testId }) {
  return (
    <div className="col-span-2 sm:col-span-1">
      <label className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B5527] block mb-2">{label}</label>
      <select data-testid={testId} className="w-full bg-transparent border-b border-[#1F3A5F]/30 px-1 py-2 outline-none focus:border-[#1F3A5F] font-serif text-base">
        {options.map(o => <option key={o}>{o}</option>)}
      </select>
    </div>
  );
}
